export const getIsSpecialDomain = (hostname: string) => {
  const specialCaseDomains = [
    'solidsport.com',
    'sportstage.se',
    'local.sportstage.se'
  ]
  return specialCaseDomains.includes(hostname)
}
